import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 5v8h-8","key":"svg-0"}],["path",{"d":"M17 9v8h-8","key":"svg-1"}]]

/**
 * IconChevronsDownRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbnMtZG93bi1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTMgNXY4aC04IiAvPgogIDxwYXRoIGQ9Ik0xNyA5djhoLTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/chevrons-down-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronsDownRight = createReactComponent('outline', 'chevrons-down-right', 'ChevronsDownRight', __iconNode);

export default IconChevronsDownRight;